import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import {
  getAmplifyEnvironment,
  generateAmplifyConfig,
  getMissingEnvVars,
} from './utils/amplifyConfig';
import ConfigError from './components/ConfigError/ConfigError';
import { isFramed } from './utils/frameGuard';
import { initAnalytics } from './utils/analytics';

// Never start the app inside a frame (utils/frameGuard.ts). The framer sees
// only the static landing card from public/index.html, so the login form and
// account pages cannot be framed for clickjacking.
if (!isFramed()) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  // AWS Amplify Configuration - Using SAM-managed resources from env vars.
  // Fail hard if required config is missing rather than rendering a broken app.
  const env = getAmplifyEnvironment();
  const missing = getMissingEnvVars(env);

  if (missing.length > 0) {
    // Log names only (never values) per the PII-redaction rule.
    console.error(
      `[PropWise] Missing required environment variables: ${missing.join(', ')}. ` +
      'App cannot start — rebuild with a complete .env from the SAM stack outputs.'
    );
    root.render(<ConfigError missing={missing} />);
  } else {
    Amplify.configure(generateAmplifyConfig(env));
    // GA4 (task 26). Here, not in public/index.html: only an unframed page
    // with a complete config loads the tag, and the env switch can turn it
    // off. A no-op when no measurement id is configured.
    initAnalytics();
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
